import React from 'react';
import SiteFooter from '../components/SiteFooter';

export default function PrivacyPolicyPage() {
  const paragraphs = [
  "Редакція від 13.02.2026",
  "1. Загальні положення",
  "1.1. Обробка персональних даних здійснюється відповідно до Закону України «Про захист персональних даних».",
  "1.2. Контакт: knyhoobih@gmail.com",
  "2. Дані, що обробляються",
  "- Email користувача;",
  "- Дані акаунта;",
  "- Дані про оплату (сума, статус, ID транзакції).",
  "3. Платежі",
  "3.1. Платіжні дані картки обробляються виключно платіжним провайдером.",
  "3.2. Сервіс не зберігає CVV, номер картки або інші реквізити.",
  "4. Мета обробки",
  "- Надання послуг;",
  "- Виконання бухгалтерських та податкових вимог;",
  "5. Права користувача",
  "Користувач має право на доступ, зміну або видалення своїх даних шляхом звернення на email."
  ];

  return (
    <div style={{ background: '#F6F4EF', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <main style={{ maxWidth: 900, margin: '0 auto', padding: '24px 16px', width: '100%', flex: 1 }}>
        <section
          style={{
            background: '#fff',
            border: '1px solid #e5e7eb',
            borderRadius: 14,
            padding: '20px 16px',
          }}
        >
          <h1 style={{ margin: '0 0 8px', color: '#0b5226' }}>ПОЛІТИКА КОНФІДЕНЦІЙНОСТІ «КНИГООБІГ»</h1>
          {paragraphs.map((text, idx) => (
            <p
              key={idx}
              style={{
                margin: idx === paragraphs.length - 1 ? 0 : '0 0 10px',
                color: '#374151',
                lineHeight: 1.6,
              }}
            >
              {text}
            </p>
          ))}
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
